import { AgentSurfacePlaceholder } from "@/pages/agent/components/agent-surface-placeholder";

export const AgentActivitiesPage = () => {
  return (
    <AgentSurfacePlaceholder
      eyebrow="Activities"
      title="Activities"
      description="Activity list content will live here."
    />
  );
};
